/**
 * Branded title bar for the public live dashboard. The logo links home; when an
 * event is provided, its name, live status, and last-updated time render in the
 * bar (no "HitClays Live" wordmark — the logo carries the brand).
 */
import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

interface LeaderboardHeaderProps {
  eventName?: string;
  lastUpdated?: string | null;
  statusNode?: ReactNode;
}

export function LeaderboardHeader({
  eventName,
  lastUpdated,
  statusNode,
}: LeaderboardHeaderProps): JSX.Element {
  return (
    <header className="app-header">
      <Link to="/" className="app-header-brand" aria-label="HitClays live dashboard home">
        <img src="/logo.svg" alt="HitClays" className="app-header-logo" />
      </Link>
      {eventName && (
        <div className="header-event">
          <div className="header-event-top">
            <h1 className="header-event-name">{eventName}</h1>
            {statusNode}
          </div>
          {lastUpdated && (
            <p className="header-updated">
              Updated {new Date(lastUpdated).toLocaleTimeString()}
            </p>
          )}
        </div>
      )}
    </header>
  );
}
